import React from 'react'
import Contact from '../components/Contact'
import Navbar from '../components/Navbar';
const Others = () => {
  return (
   <div className='flex flex-col'>
   <Navbar/>
   <Contact/>
   </div>
  );
}

export default Others
